
<template>
    <div class="center">
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table>
            <template #thead>
                <tr>
                    <editar v-model="activeEditar" :selectInfo="selectInfo" @refreshTable="getRefresh"></editar>
                    <eliminar v-model="activeEliminar" :selectInfo="selectInfo" @refreshTable="getRefresh"></eliminar>
                </tr>
                <vs-tr>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'name')">
                        Nombre
                    </vs-th>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'email')">
                        Gravable
                    </vs-th>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'id')">
                        Reembolsable
                    </vs-th>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'id')">
                        Deducible
                    </vs-th>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'id')">
                        No.Registros relacionados
                    </vs-th>
                    <vs-th v-if="JSON.parse(personaRol).roles[0].id == 1" sort @click="users = $vs.sortData($event ,users, 'id')">
                        Acciones
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in $vs.getSearch(users, search)"
                    :data="tr"
                >
                    <vs-td>
                        <p class="mb-0"><strong>{{tr.nombre}}</strong></p>
                        <p class="mb-0"><i><small>CLAVE: </small></i><strong> {{tr.clave}}</strong></p>
                        <p class="mb-0"><i><small>TIPO: </small></i><strong><span  style="text-transform: uppercase;"> {{tr.tipo}} </span></strong></p>
                    </vs-td>
                    <vs-td class="text-center">
                        <md-chip class="mb-1 fontMedium mini-chip" :class="getInfo(tr.gravable)"><strong><span style="text-transform: uppercase;"> {{tr.gravable}}</span> </strong></md-chip>
                    </vs-td>
                    <vs-td class="text-center">
                        <md-chip class="mb-1 fontMedium mini-chip" :class="getInfo(tr.reembolsable)"><strong><span style="text-transform: uppercase;"> {{tr.reembolsable}}</span> </strong></md-chip>
                    </vs-td>
                    <vs-td class="text-center">
                        <md-chip class="mb-1 fontMedium mini-chip" :class="getInfo(tr.deducible)"><strong><span style="text-transform: uppercase;"> {{tr.deducible}}</span> </strong></md-chip>
                    </vs-td>
                    <vs-td class="text-center">
                        <strong>{{tr.NoModelosRelacionados}}</strong>
                    </vs-td>
                    <vs-td v-if="JSON.parse(personaRol).roles[0].id == 1">
                        <vs-row>
                            <vs-col sm="6" lg="6"> 
                                <vs-button
                                    icon
                                    success
                                    size="mini"
                                    class="m-auto"
                                    @click="activeEditar = ! activeEditar, selectInfo = tr"
                                >
                                    <i class="far fa-edit" style="font-size: 10px"></i>
                                </vs-button>
                            </vs-col>
                            <vs-col sm="6" lg="6">
                                <vs-button
                                    v-if="tr.NoModelosRelacionados == 0"
                                    icon
                                    danger
                                    size="mini"
                                    class="m-auto"
                                    @click="activeEliminar = ! activeEliminar, selectInfo = tr"
                                >
                                    <i class="far fa-trash-alt" style="font-size: 10px"></i>
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
    </div>
</template>
<script>
import editar from './modales/editar.vue'
import eliminar from './modales/eliminar'
    export default {
        props:[
            'users',
            'tipo',
            'personaRol'
        ],
        data:() => ({
            search: '',
            activeEditar: false,
            activeEliminar: false,
            selectInfo: []
        }),
        components: {
            editar,
            eliminar
        },
        methods: {
            getInfo(info){
                if(info == 'si'){
                    return 'col-blue'
                }else if(info == 'no'){
                    return 'col-pink'
                }
            },
            getRefresh(){
                this.$emit('refreshTable')
            }
        }
    }
</script>

<style lang="scss" scoped>


    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }
</style>

        